<template>
  <div class="app-content-wrapper">
    <div class="search-wrapper">
      <search-component ref="search" :search-buttons="searchButtonList" :search-condition="searchCondition"
        :fuzzySearchPlaceholder="fuzzySearchPlaceholder" :isDisplayReset="true" :showMerchantSearch="true"
        router-name="/subscription/order">
      </search-component>
    </div>
    <div class="table-wrapper">
      <custom-table :table-set="tableCondition" :service-function="getSubscriptionList" :showMerchantNo="true"
        :first-parameters="firstParameters" ref="table" router-name="/subscription/order">
      </custom-table>
    </div>
    <custom-message ref="customMessage"></custom-message>
  </div>
</template>
<script>
import CustomMessage from '@/components/modal/message-box/custom-message.vue';
import { ShowSuccessMessage } from '@/components/modal/tips/message-tips';
import CustomTable from '@/components/table/custom-table.vue';
import SearchComponent from '@/components/table/search-component.vue';
import GlobalData from '@/utils/global/index';
import { getEnantiomericValue, initSelectedData } from '@/utils/tools/constant';
import { getTodayParams } from '@/utils/tools/time';
import { getSubscriptionList, exportSubscriptionList } from '@/views/subscription/api/subscription';
export default {
  components: {
    SearchComponent,
    CustomMessage,
    CustomTable,
  },
  data() {
    return {
      noDataString: '--',
      lang: this.$store.state.app.currentLan,
      getTodayParams,
      appItem: {},
      appTypeList: [],
      appTypeListAndAll: [],
      statusesList: [],
      paymentMethodList: [],
      fuzzySearchPlaceholder: `${this.$t('message.subscription.contractId')}`,
      searchCondition: [
        {
          key: 'email',
          name: 'message.account.customEmail',
          type: 'input',
          defValue: '',
        },
        {
          key: 'subscriptionStatus',
          name: 'message.tableCommon.status',
          type: 'select',
          multiple: true,
          // paymentdue  pastdue
          defValue: ['trialing', 'active'],
          option: {
            label: 'description',
            value: 'value',
          },
          isInternationalization: true,
          options: [],
          changeValue: (value) => {
            let list = [];
            if ((value[value.length - 1] === '')) {
              list = [''];
            } else {
              list = value.filter((item) => item !== '');
            }
            this.$refs.search.setInputValue('subscriptionStatus', list);
          },
        },
        {
          key: 'selfExecute',
          name: 'message.subscription.collectionMethod',
          type: 'select',
          defValue: '',
          isInternationalization: true,
          options: [
            { label: 'message.searchCommon.all', value: '' }, // 全部
            { label: 'message.subscription.paymentMethodData.1', value: '1' }, // 自动
            { label: 'message.subscription.paymentMethodData.2', value: '2' }, // 商户发起
          ],
        },
      ],
      downloading: false,
      searchButtonList: [
        {
          type: 'other',
          name: 'message.settlement.export',
          permissionCode: 'subscribe:query:download',
          func: async (params) => {
            if (!this.downloading) {
              const data = {
                ...params,
              };
              this.downloading = true;
              await exportSubscriptionList(data);
              ShowSuccessMessage(this.$t('message.common.downloadTask'));
              this.downloading = false;
            }
          },
        },
      ],
      tableCondition: [
        { // 订阅合同号
          key: 'contractId',
          titleBar: { type: 'text', title: 'message.subscription.contractNo', filterKey: 'contractId' },
          type: 'click',
          itemWidth: '250px',
          subTableDisplays: [
            {
              type: 'text_button',
              key: 'contractId',
              textFunc: (data) => data.contractId || this.noDataString,
              func: (data) => {
                this.$router.push({ path: '/subscription/order/detail', query: { contractId: data.contractId, merchantNo: data.merchantNo } });
              },
            },
          ],
        },
        { // 开始日期
          titleBar: { type: 'text', title: 'message.subscription.startDate' },
          key: 'createDate',
          type: 'text',
          textFunc: (data) => data.createDate || this.noDataString,
        },
        { // 到期日期
          titleBar: { type: 'text', title: 'message.subscription.expireDate' },
          key: 'expireDate',
          type: 'text',
          textFunc: (data) => data.expireDate || this.noDataString,
        },
        { // 扣款频率
          titleBar: { type: 'text', title: 'message.subscription.frequency' },
          key: 'frequencyPoint',
          type: 'text',
          textFunc: (data) => {
            // proxy.$t(`message.subscription.frequencyData[${data.frequencyType}]`, { day: data.frequencyPoint });
            switch (data.frequencyType) {
            case 'D':
              // TODO:着急上线后续补上
              if (this.lang === 'en') {
                return `per ${data.frequencyPoint} ${data.frequencyPoint === 1 ? 'day' : 'days'}`;
              } else {
                return `每${data.frequencyPoint}天/次`;
              }
            case 'M':
              // TODO:着急上线后续补上
              if (this.lang === 'en') {
                return `per ${data.frequencyPoint} ${data.frequencyPoint === 1 ? 'month' : 'months'}`;
              } else {
                return `每${data.frequencyPoint}月/次`;
              }

            case 'W':
              // TODO:着急上线后续补上

              if (this.lang === 'en') {
                return `per ${data.frequencyPoint} ${data.frequencyPoint === 1 ? 'week' : 'weeks'}`;
              } else {
                return `每${data.frequencyPoint}周/次`;
              }
            case 'Y':
              // TODO:着急上线后续补上

              if (this.lang === 'en') {
                return `per ${data.frequencyPoint} ${data.frequencyPoint === 1 ? 'year' : 'years'}`;
              } else {
                return `每${data.frequencyPoint}年/次`;
              }
            default:
              return this.noDataString;
            }
          },
        },
        { // 付款方式
          titleBar: { type: 'text', title: 'message.subscription.collectionMethod', filterKey: 'selfExecute' },
          key: 'selfExecute',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.paymentMethodList, data.selfExecute),
        },
        {
          titleBar: { type: 'text', title: 'message.subscription.email' },
          key: 'notificationEmail',
          type: 'text',
          textFunc: (data) => data.notificationEmail || this.noDataString,
        },
        { // 状态
          titleBar: { type: 'text', title: 'message.tableCommon.status' },
          key: 'subscriptionStatus',
          type: 'text',
          textFunc: (data) => getEnantiomericValue(this.statusesList, data.subscriptionStatus),
          itemStyle: (data) => this.getSubscriptionStatusStyle(data.subscriptionStatus),
          tooltipTextFunc: (data) => {
            // 为不同状态返回不同的提示内容
            // 仅生效中，且扩展状态为更新中或取消中时，返回提示内容
            if (data.subscriptionStatus === 'active' && (['updating', 'cancelling'].includes(data.extendedStatus))) {
              return 'message.subscription.statusActiveTip';
            }
            return undefined;
          },
        },
        {
          key: 'buttons',
          titleBar: { title: 'message.tableCommon.operation', type: 'operations' },
          type: 'operations',
          subTableDisplays: [
            { // 详情
              type: 'text_button',
              permissionCode: 'subscription:order:detail',
              textFunc: () => 'message.tableCommon.details',
              func: (data) => {
                this.$router.push({ path: '/subscription/order/detail', query: { contractId: data.contractId, merchantNo: data.merchantNo } });
              },
            },
            {
              type: 'text_button',
              isDisplayFunc: (data) => data.subscriptionStatus === 'active' && data.dataStatus === '1' && data.selfExecute !== '2',
              textFunc: () => 'message.common.edit',
              func: (data) => {
                this.$router.push({ path: '/subscription/order/detail', query: { contractId: data.contractId, merchantNo: data.merchantNo, type: 'edit' } });
              },
            },
            // { // 取消
            //   type: 'text_button',
            //   permissionCode: 'subscribe:query:cancel',
            //   textFunc: () => 'message.tableCommon.cancel',
            //   isDisplayFunc: (data) => data.dataStatus === '1',
            //   func: (data) => {
            //     this.$refs.customMessage.openHttpModal({
            //       contentHtml: `${this.$t('message.subscription.cancelConfirm')}?`,
            //       httpFunction: unsubscrible,
            //       params: { contractId: data.contractId },
            //       successFunction: this.onRefreshTable,
            //     });
            //   },
            // },
          ],
        },
      ],
      firstParameters: {
        subscriptionStatus: ['trialing', 'active'].join(','),
      },
    };
  },
  mounted() {
    this.initMethod();
  },
  methods: {
    getSubscriptionList,
    /**
     * 刷新当前表单
     */
    onRefreshTable() {
      this.$refs.table.refreshTable();
    },

    getSubscriptionStatusStyle(code) {
      const obj = {
        trialing: 'success',
        paymentdue: 'pending',
        active: 'success',
        pastdue: 'fail',
        paused: 'fail',
        canceled: 'disabled',
        ended: 'disabled',
      };
      function getStatusStyle(status) {
        let style = '';
        if (!status) {
          return style;
        }
        switch (status) {
        case 'success':
          style += 'background-color:#D9FFE0';
          break;
        case 'fail':
          style += 'background-color:#FFE8E0';
          break;
        case 'pending':
          style += 'background-color:#E0E0FF';
          break;
        case 'disabled':
          style += 'background-color:#D9D9D9';
          break;
        default:
          break;
        }

        return style ? `padding:0 10px;height:30px;text-align:center;border-radius:4px;font-weight:800;line-height:30px;${style}` : '';
      }
      return getStatusStyle(obj[`${code}`]);
    },

    async initMethod() {
      const dict = await GlobalData.getDictList(['SUBSCRIPTION_STATUS', 'SUBSCRIPTION_PAYMENT_METHOD']);
      this.statusesList = initSelectedData(dict.SUBSCRIPTION_STATUS);
      this.paymentMethodList = initSelectedData(dict.SUBSCRIPTION_PAYMENT_METHOD);
      this.$refs.search.setSearchSelectOptions('subscriptionStatus', this.statusesList);
      this.$refs.search.setSearchSelectOptions('selfExecute', this.paymentMethodList);
      this.onRefreshTable();
    },

  },
};
</script>
